module.exports = __webpack_public_path__ + "static/media/instagram-1.ef66466a.svg";